/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const SubLoanDetailPage = lazyLoad(
  () => import('./index'),
  module => module.SubLoanDetailPage,
);
